import React, { useState, useEffect } from "react";
import { useUpdateLeaveAllocation } from "../../../api/queries/leaveQueries";
import { getApiErrorMessage } from "../../../utils/apiError";

// Added onSuccess prop to trigger re-fetch in parent
const AllocateLeaveModal = ({ isOpen, onClose, leaveData, onSuccess }) => {
  const [newAllocation, setNewAllocation] = useState(0);
  const updateAllocation = useUpdateLeaveAllocation();
  const isSaving = updateAllocation.isPending;

  useEffect(() => {
    if (isOpen && leaveData) {
      setNewAllocation(parseFloat(leaveData.allocated) || 0);
    }
  }, [isOpen, leaveData]);

  if (!isOpen) return null;

  const handleSave = async () => {
    try {
      await updateAllocation.mutateAsync({
        employeeId: leaveData.employeeId,
        leaveTypeId: leaveData.leaveTypeId,
        // The anniversary cycle this balance belongs to (old rows: calendar year)
        periodStart: leaveData.periodStart || undefined,
        year: leaveData.periodStart ? undefined : leaveData.year,
        allocatedDays: newAllocation,
      });
      alert("Leave allocation updated successfully!");
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.error("Failed to update allocation:", err);
      alert("Error: " + getApiErrorMessage(err, "Could not update allocation"));
    }
  };

  return (
    // ... (rest of your modal JSX remains the same)
    <div className="modal show d-block bg-dim">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Allocate {leaveData?.leaveType?.name}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isSaving}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-bold">
                New Allocation Amount
              </label>
              <input
                type="number"
                className="form-control"
                value={newAllocation}
                onChange={(e) => setNewAllocation(parseFloat(e.target.value))}
                disabled={isSaving}
              />
            </div>
            <p className="text-muted small">
              Current Balance: {leaveData?.allocated}
            </p>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isSaving}
            >
              Close
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllocateLeaveModal;
